(function() {
  const popup = document.querySelector('[data-newsletter-popup]');
  if (!popup) return;

  const closeBtn = popup.querySelector('[data-newsletter-close-btn]');
  const noThanksBtn = popup.querySelector('[data-newsletter-no-thanks-btn]');
  const overlay = popup.querySelector('[data-newsletter-overlay]');
  const ctaBtn = popup.querySelector('[data-newsletter-cta-btn]');
  const newsletterFormContainer = popup.querySelector('[data-newsletter-form]');
  const newsletterSubmitBtn = popup.querySelector('[data-popup-newsletter-form] button[type="submit"]');

  function openPopup() {
    popup.removeAttribute('hidden');
    popup.setAttribute('open', '');
    popup.setAttribute('active', '');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.removeAttribute('open');
    popup.removeAttribute('active');
    popup.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  const triggerElements = document.querySelectorAll('[data-icon-email]');
  triggerElements.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openPopup();
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  if (noThanksBtn) {
    noThanksBtn.addEventListener('click', closePopup);
  }

  if (overlay) {
    overlay.addEventListener('click', closePopup);
  }

  let isNewsletterVisible = false;
  if (newsletterSubmitBtn) {
    newsletterSubmitBtn.style.display = 'none';
  }

  if (ctaBtn) {
    ctaBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!isNewsletterVisible) {
        if (newsletterFormContainer) {
          newsletterFormContainer.removeAttribute('hidden');
          isNewsletterVisible = true;
          const newsletterForm = popup.querySelector('form[data-type="newsletter"]');
          if (newsletterForm && newsletterForm.id) {
            const initFunction = window['initNewsletterForm_' + newsletterForm.id];
            if (initFunction && typeof initFunction === 'function') {
              setTimeout(initFunction, 100);
            }
          }
        }
        if (newsletterSubmitBtn) {
          newsletterSubmitBtn.style.display = 'none';
        }
      } else {
        const newsletterForm = popup.querySelector('form[data-type="newsletter"]');
        if (newsletterForm) {
          if (newsletterForm.checkValidity()) {
            if (newsletterForm.requestSubmit) {
              newsletterForm.requestSubmit();
            } else {
              const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
              newsletterForm.dispatchEvent(submitEvent);
            }
          } else {
            newsletterForm.reportValidity();
          }
        }
      }
    });
  }
})();
